export default __webpack_public_path__ + "static/media/intermissionLoop.54cb8be0.mp3";